import React, { useState, useEffect } from "react";
import styles from "./Slider.module.scss";
import StepIndicator from "../../../common/ekedc-components/step-indicator/StepIndicator";

export interface Slide {
	titleRow1: string;
	titleRow2: string;
	subText: string;
	gradient: string;
	image?: string;
	gif?: string;
	gifPosition?: "left" | "right";
}

interface SliderProps {
	slides: Array<Slide>;
	duration?: number;
	autoPlay?: boolean;
}

const Slider = ({ slides, duration = 5000, autoPlay = true }: SliderProps) => {
	const [currentSlide, setCurrentSlide] = useState(0);

	useEffect(() => {
		if (!autoPlay || slides.length <= 1) return;

		const interval = setInterval(() => {
			setCurrentSlide(prev => (prev + 1) % slides.length);
		}, duration);

		return () => clearInterval(interval);
	}, [duration, autoPlay, slides.length]);

	const goToSlide = (index: number) => {
		if (index >= 0 && index < slides.length) {
			setCurrentSlide(index);
		}
	};

	const renderMedia = (slide: Slide) => {
		if (slide.image && slide.gif) {
			const gifPositionClass = slide.gifPosition === "left" ? styles.mockupGifLeft : styles.mockupGifRight;
			return (
				<div className={styles.imageContainer}>
					<div className={styles.mockupWrapper}>
						<img src={slide.gif} alt={slide.titleRow1 + " " + slide.titleRow2} className={`${styles.mockupGif} ${gifPositionClass}`} />
						<img src={slide.image} alt="" className={styles.mockupFrame} />
					</div>
				</div>
			);
		}

		if (slide.image) {
			return (
				<div className={styles.imageContainer}>
					<img src={slide.image} alt={slide.titleRow1 + " " + slide.titleRow2} />
				</div>
			);
		}

		if (slide.gif) {
			return (
				<div className={styles.imageContainer}>
					<img src={slide.gif} alt={slide.titleRow1 + " " + slide.titleRow2} />
				</div>
			);
		}

		return null;
	};

	return (
		<div className={styles.sliderContainer}>
			<div className={styles.slidesWrapper}>
				{slides.map((slide, index) => (
					<div
						key={index}
						className={`${styles.slide} ${index === currentSlide ? styles.active : ""}`}
					>
						<div className={styles.content}>
							<h2>
								<span className={styles.title}>{slide.titleRow1}</span>
								<span className={styles.title}>{slide.titleRow2}</span>
							</h2>
							<p className={styles.subTitle}>{slide.subText}</p>
							{renderMedia(slide)}
						</div>
					</div>
				))}

				<div
					className={`${styles.touchArea} ${styles.left}`}
					onClick={() => goToSlide((currentSlide - 1 + slides.length) % slides.length)}
				/>
				<div
					className={`${styles.touchArea} ${styles.right}`}
					onClick={() => goToSlide((currentSlide + 1) % slides.length)}
				/>
			</div>

			{slides.length >= 1 && (
				<div className={styles.indicators}>
					<StepIndicator total={slides.length} current={currentSlide} onStepClick={goToSlide} />
				</div>
			)}
		</div>
	);
};

export default Slider;
